import React, { useState } from 'react';
import contactImage from '../../imgs/lrm-menu.png';
import './ContactSection.css';

const initialForm = { name: '', email: '', subject: '', message: '' };

function ContactForm() {
  const [formData, setFormData] = useState(initialForm);
  const [status, setStatus] = useState({ state: 'idle', message: '' });

  const isSubmitting = status.state === 'submitting';

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ state: 'submitting', message: 'Sending your message…' });

    try {
      const response = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          access_key: 'your-web3forms-access-key',
          ...formData,
        }),
      });

      if (response.ok) {
        setStatus({
          state: 'success',
          message: "Message sent. We'll be in touch shortly.",
        });
        setFormData(initialForm);
      } else {
        setStatus({
          state: 'error',
          message: 'Failed to send message. Please try again later.',
        });
      }
    } catch (err) {
      setStatus({
        state: 'error',
        message: 'Network error. Please try again later.',
      });
    }
  };

  return (
    <section className="contact-section">
      <div className="contact-container">
        <header className="contact-header">
          <span className="contact-eyebrow">
            Contact
          </span>
          <h1 className="contact-title">Get in Touch</h1>
          <p className="contact-subtitle">
            Booking inquiries, brand partnerships, or press. Send us a note and our team will respond shortly.
          </p>
        </header>

        <div className="contact-grid">
          <aside className="contact-aside">
            <div className="contact-aside-media">
              <img
                src={contactImage}
                alt="LRM Management"
                className="contact-hero-image"
              />
            </div>
            <ul className="contact-meta">
              <li>
                <span className="contact-meta-label">Email</span>
                <a href="mailto:info@lrmmanagement.com" className="contact-meta-value">
                  info@lrmmanagement.com
                </a>
              </li>
              <li>
                <span className="contact-meta-label">Representation</span>
                <span className="contact-meta-value">
                  Talent · Tours · Brand Partnerships
                </span>
              </li>
              <li>
                <span className="contact-meta-label">Response Time</span>
                <span className="contact-meta-value">Within 1 to 2 business days</span>
              </li>
            </ul>
          </aside>

          <form onSubmit={handleSubmit} className="contact-form" noValidate>
            <div className="form-row form-row--split">
              <div className="form-group">
                <label htmlFor="contact-name" className="form-label">Name</label>
                <input
                  id="contact-name"
                  type="text"
                  name="name"
                  placeholder="Your name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="contact-email" className="form-label">Email</label>
                <input
                  id="contact-email"
                  type="email"
                  name="email"
                  placeholder="you@email.com"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="contact-subject" className="form-label">Subject</label>
              <input
                id="contact-subject"
                type="text"
                name="subject"
                placeholder="Booking, partnership, press…"
                value={formData.subject}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="contact-message" className="form-label">Message</label>
              <textarea
                id="contact-message"
                name="message"
                placeholder="Tell us a little about your inquiry"
                rows="5"
                value={formData.message}
                onChange={handleChange}
                required
              />
            </div>

            <button
              type="submit"
              className="submit-button"
              disabled={isSubmitting}
              aria-busy={isSubmitting}
            >
              <span className="submit-button-label">
                {isSubmitting ? 'Sending' : 'Send Message'}
              </span>
              <span className="submit-button-arrow" aria-hidden="true">
                {isSubmitting ? '…' : '→'}
              </span>
            </button>

            {status.state !== 'idle' && (
              <p
                className={`form-status form-status--${status.state}`}
                role="status"
                aria-live="polite"
              >
                {status.message}
              </p>
            )}
          </form>
        </div>
      </div>
    </section>
  );
}

export default ContactForm;
